import {
	RemoveImportRowsMutation,
	RevalidateImportMutation,
	UpdateProductionLotAsyncImportJobRowsMutation
} from "~/gql/mutations/produce/asyncImportJob.generated";
import { GetProductionLotAsyncImportJobNewPlansQuery } from "~/gql/queries/produce/asyncImportJob.generated";

const asyncImportJobEndpoints = {
	GetProductionLotAsyncImportJobNewPlans: {
		providesTags: ["AsyncImportJob"] as AddTagTypes,
		transformResponse: (res: GetProductionLotAsyncImportJobNewPlansQuery) => {
			return res;
		}
	},
	RemoveImportRows: {
		invalidatesTags: ["AsyncImportJob"] as AddTagTypes,
		transformResponse: (res: RemoveImportRowsMutation) => {
			return res;
		}
	},
	RevalidateImport: {
		invalidatesTags: ["AsyncImportJob"] as AddTagTypes,
		transformResponse: (res: RevalidateImportMutation) => {
			return res;
		}
	},
	UpdateProductionLotAsyncImportJobRows: {
		invalidatesTags: ["AsyncImportJob"] as AddTagTypes,
		transformResponse: (res: UpdateProductionLotAsyncImportJobRowsMutation) => {
			return res;
		}
	}
};

export default asyncImportJobEndpoints;
